import { FC } from 'react';

import { NavMainTopbarItem } from '@/components/blocks/topbar/nav-main-topbar-item';
import { useAppConfig } from '@/hooks/use-app-config';
import { cn } from '@/lib/utils';

interface NavMainTopbarProps {
  className?: string;
}

export const NavMainTopbar: FC<NavMainTopbarProps> = ({
  className,
}: NavMainTopbarProps) => {
  const { items } = useAppConfig();

  return (
    <div className={cn('flex flex-1 items-stretch', className)}>
      <span
        aria-hidden='true'
        className='bg-border mx-4 h-6 w-px self-center'
      />
      <nav className='flex items-stretch gap-1'>
        {items.map((item) => (
          <NavMainTopbarItem
            key={item.title}
            item={item}
          />
        ))}
      </nav>
    </div>
  );
};
